<template>
    <div class="configurator">

        <div class="configurator">

            <!--Partition Type-->
            <div class="configurator-section type-of-partition-section">
                <div id="type-of-partition-section-anchor"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 section-intro">
                            <h3>1</h3>
                            <h2>Type of Partition</h2>
                            <p>{{ typeOfPartitionText1 }}</p>
                            <img class="arrow arrow-right" src="/-/themes/main/client/dist/img/arrow-02.png">
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:class="partitionType == partition.inlineType ? activeClass : ''"
                                 v-on:click="setPartitionType(partition.inlineType)"
                                 v-bind:data-partition-type="partition.inlineType">
                                <img :src="'/-/themes/main/client/dist/img/inline-glass-box.png'">
                                <p>{{ partition.inlineType }}</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:class="partitionType == partition.cornerType ? activeClass : ''"
                                 v-on:click="setPartitionType(partition.cornerType)"
                                 v-bind:data-partition-type="partition.cornerType">
                                <img :src="'/-/themes/main/client/dist/img/corner-glass-box.png'">
                                <p>{{ partition.cornerType }}</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:class="partitionType == partition.threeSidedType ? activeClass : ''"
                                 v-on:click="setPartitionType(partition.threeSidedType)"
                                 v-bind:data-partition-type="partition.threeSidedType">
                                <img :src="'/-/themes/main/client/dist/img/three-sided-glass-box.png'">
                                <p>{{ partition.threeSidedType }}</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:class="partitionType == partition.tShapeType ? activeClass : ''"
                                 v-on:click="setPartitionType(partition.tShapeType)"
                                 v-bind:data-partition-type="partition.tShapeType">
                                <img :src="'/-/themes/main/client/dist/img/t-glass-box.png'">
                                <p>{{ partition.tShapeType }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="row section-outro">
                        <div class="col-12 col-lg-9">
                            <p>{{ typeOfPartitionText2 }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                            <div class="button-wrapper">
                                <a :href="guideToPartitionsLink" target="_blank"
                                   class="btn btn-outline-black configurator-btn">{{ guideToPartitionsLinkText }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Dimensions-->
            <div class="dimensions" style="background-image: url('/-/themes/main/client/dist/img/dimensions-bg.jpg')">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 section-intro">
                            <h3>2</h3>
                            <h2>Dimensions</h2>
                            <p>{{ dimensionsText }}</p>
                            <img class="arrow arrow-left" src="/-/themes/main/client/dist/img/arrow-01.png">
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-12 dimension-row" v-bind:class="notInlinePartition ? 'col-lg-4' : 'col-lg-6'">
                            <div class="form-group has-danger" data-label="Width">
                                <label for="partitionWidth">Width <span class="mm">mm</span></label>
                                <input id="partitionWidth" class="form-control" type="number" min="1"
                                       v-model.number="width" v-on:input="updateTotalOfAllPartitions()"
                                       :class="{ 'form-control-danger': widthWarning }"/>
                                <div v-if="widthWarning" class="form-control-feedback">{{ widthWarning }}</div>
                            </div>
                        </div>
                        <div class="col-12 dimension-row" v-bind:class="notInlinePartition ? 'col-lg-4' : 'col-lg-6'">
                            <div class="form-group has-danger" data-label="Height">
                                <label for="partitionHeight">Height <span class="mm">mm</span></label>
                                <input id="partitionHeight" class="form-control" type="number" min="1"
                                       v-model.number="height" v-on:input="updateTotalOfAllPartitions()"
                                       :class="{ 'form-control-danger': heightWarning }"/>
                                <div v-if="heightWarning" class="form-control-feedback">{{ heightWarning }}</div>
                            </div>
                        </div>
                        <div class="col-12 dimension-row" v-bind:class="notInlinePartition ? 'col-lg-4' : 'col-lg-6'">
                            <div class="form-group has-danger" data-label="Depth" v-if="notInlinePartition">
                                <label for="partitionDepth">Depth <span class="mm">mm</span></label>
                                <input id="partitionDepth" class="form-control" type="number" min="1"
                                       v-model.number="depth" v-on:input="updateTotalOfAllPartitions()"
                                       :class="{ 'form-control-danger': depthWarning }"/>
                                <div v-if="depthWarning" class="form-control-feedback">{{ depthWarning }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Glass-->
            <div class="configurator-section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 col-lg-6 section-intro">
                            <h3>3</h3>
                            <h2>Glass</h2>
                            <p>{{ glassText }}</p>
                            <img class="arrow arrow-right" src="/-/themes/main/client/dist/img/arrow-02.png">
                            <div class="button-wrapper">
                                <a :href="guideToAcousticsLink" target="_blank"
                                   class="btn btn-outline-black configurator-btn">{{ guideToAcousticsLinkText }}</a>
                            </div>
                        </div>

                        <div class="col-sm-12 col-lg-6">
                            <div class="row no-gutters">
                                <div class="col-6">
                                    <div class="configurator-tile"
                                         v-bind:data-glazing-type="partition.singleGlazingType"
                                         v-bind:class="glazingType == partition.singleGlazingType ? activeClass : ''"
                                         v-on:click="setGlazingType(partition.singleGlazingType)"
                                    >
                                        <img src="/-/themes/main/client/dist/img/glass-single.png">
                                        <p>Single Glazed</p>
                                    </div>
                                </div>

                                <div class="col-6">
                                    <div class="configurator-tile"
                                         v-bind:data-glazing-type="partition.doubleGlazingType"
                                         v-bind:class="glazingType == partition.doubleGlazingType ? activeClass : ''"
                                         v-on:click="setGlazingType(partition.doubleGlazingType)">
                                        <img src="/-/themes/main/client/dist/img/glass-double.png">
                                        <p>Double Glazed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="glazingType == partition.singleGlazingType">

                        <div class="col-sm-12 col-lg-6 order-1 order-lg-2 section-intro pt-5">
                            <h2>Acoustic Performance</h2>
                            <p>{{ acousticPerformanceText }}</p>
                            <img class="arrow arrow-left" src="/-/themes/main/client/dist/img/arrow-01.png">
                        </div>

                        <div class="col-sm-12 col-lg-6 order-2 order-lg-1 pt-5">
                            <div class="row no-gutters">
                                <div class="col-6">
                                    <div class="configurator-tile"
                                         v-bind:data-acoustic-performance="partition.singleGlazed33dB"
                                         v-bind:class="acousticPerformance == partition.singleGlazed33dB ? activeClass : ''"
                                         v-on:click="setAcousticPerformance(partition.singleGlazed33dB)"
                                    >
                                        <img :src="'/-/themes/main/client/dist/img/single-glazed-33db.png'">
                                        <p>Toughened</p>
                                    </div>
                                </div>

                                <div class="col-6">
                                    <div class="configurator-tile"
                                         v-bind:data-acoustic-performance="partition.singleGlazed38dB"
                                         v-bind:class="acousticPerformance == partition.singleGlazed38dB ? activeClass : ''"
                                         v-on:click="setAcousticPerformance(partition.singleGlazed38dB)">
                                        <img :src="'/-/themes/main/client/dist/img/single-glazed-38db.png'">
                                        <p>Acoustic Laminated</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <!--Door-->
            <div class="configurator-section doors-section">
                <div class="container d-lg-none">
                    <div class="row">
                        <div class="col-sm-12 section-intro">
                            <h3>4</h3>
                            <h2>Select a door</h2>
                            <p>{{ doorText }}</p>
                            <img class="arrow arrow-left" src="/-/themes/main/client/dist/img/arrow-01.png">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6 col-lg-3" v-for="(description, option) in singleGlazedDoorOptions"
                             v-if="isSingleGlazed">
                            <div class="configurator-tile"
                                 v-bind:data-door-type="option"
                                 v-bind:class="door == option ? activeClass : ''"
                                 v-on:click="setDoor(option)">
                                <img :src="description.imgPathSmall">
                                <p>{{ description.name }}</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3" v-for="(description, option) in doubleGlazedDoorOptions"
                             v-if="isDoubleGlazed">
                            <div class="configurator-tile"
                                 v-bind:data-door-type="option"
                                 v-bind:class="door == option ? activeClass : ''"
                                 v-on:click="setDoor(option)">
                                <img :src="description.imgPathSmall">
                                <p>{{ description.name }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="row section-outro">
                        <div class="col-12 col-lg-12">
                            <div class="button-wrapper">
                                <a :href="guideToDoorsLink" target="_blank"
                                   class="btn btn-filled-black configurator-btn">{{ guideToDoorsLinkText }}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-none d-lg-block large-doors">
                    <div class="container">
                        <div class="row">
                            <div class="col-1">
                                <h3>4</h3>
                            </div>
                            <div class="col-8">
                                <table class="door-controls">
                                    <tr>
                                        <td v-for="(description, option) in singleGlazedDoorOptions"
                                            v-bind:data-door-type="option"
                                            v-on:click="setDoor(option, description.imgPathLarge)"
                                            v-if="isSingleGlazed">
                                            {{ description.name }}
                                        </td>
                                        <td v-for="(description, option) in doubleGlazedDoorOptions"
                                            v-bind:data-door-type="option"
                                            v-on:click="setDoor(option, description.imgPathLarge)"
                                            v-if="isDoubleGlazed">
                                            {{ description.name }}
                                        </td>
                                    </tr>
                                </table>
                                <img :src="baseDoorImage" class="door-image base-door-image">

                                <template v-for="(description, option) in singleGlazedDoorOptions">
                                    <img :src="description.imgPathLarge" :class="{ show: door === option}"
                                         class="door-image selected-door-image">
                                </template>

                                <template v-for="(description, option) in doubleGlazedDoorOptions">
                                    <img :src="description.imgPathLarge" :class="{ show: door === option}"
                                         class="door-image selected-door-image">
                                </template>

                            </div>
                            <div class="col-3 information">
                                <h2>Select a door</h2>
                                <p>{{ doorText }}</p>
                                <img class="arrow arrow-left" src="/-/themes/main/client/dist/img/arrow-01.png">
                                <!--the data link is to stop the labels from the doors jumping up in ms edge-->
                                <!--see TGOP-39 Configurator door frame title jump upon going to door guides and main.js-->
                                <button :data-link="guideToDoorsLink" id="guide-to-doors"
                                        class="btn btn-filled-black configurator-btn">{{ guideToDoorsLinkText }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Ironmongery-->
            <div class="configurator-section" v-if="door !== partition.door.noDoor">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 section-intro section-intro--no-number">
                            <h2>Ironmongery</h2>
                            <p>{{ ironmongeryText1 }}</p>
                            <img class="arrow arrow-left" src="/-/themes/main/client/dist/img/arrow-01.png">
                        </div>
                    </div>

                    <div class="row no-gutters">

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-ironmongery="partition.door.ironmongeryDHandle"
                                 v-bind:class="ironmongery == partition.door.ironmongeryDHandle ? activeClass : ''"
                                 v-on:click="setIronmongery(partition.door.ironmongeryDHandle)">
                                <img :src="'/-/themes/main/client/dist/img/d-handles.png'">
                                <p>D Handle</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-ironmongery="partition.door.ironmongeryManet"
                                 v-bind:class="ironmongery == partition.door.ironmongeryManet ? activeClass : ''"
                                 v-on:click="setIronmongery(partition.door.ironmongeryManet)">
                                <img :src="'/-/themes/main/client/dist/img/manet-pull-handles.png'">
                                <p>Manet</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-ironmongery="partition.door.ironmongeryLeverLock"
                                 v-bind:class="ironmongery == partition.door.ironmongeryLeverLock ? activeClass : ''"
                                 v-on:click="setIronmongery(partition.door.ironmongeryLeverLock)">
                                <img :src="'/-/themes/main/client/dist/img/lever-locking-handles.png'">
                                <p>Lever Lock</p>
                            </div>
                        </div>

                    </div>

                    <div class="row section-outro">
                        <div class="col-12 col-lg-9">
                            <p>{{ ironmongeryText2 }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                            <div class="button-wrapper">
                                <a :href="guideToIronmongeryLink" target="_blank"
                                   class="btn btn-outline-black configurator-btn">{{ guideToIronmongeryLinkText }}</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!--Manifestations-->
            <div class="configurator-section">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 section-intro">
                            <h3>6</h3>
                            <h2>Manifestations</h2>
                            <p>{{ manifestationsText1 }}</p>
                            <img class="arrow arrow-left" src="/-/themes/main/client/dist/img/arrow-01.png">
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-manifestation-type="'dots'"
                                 v-bind:class="manifestation == 'dots' ? activeClass : ''"
                                 v-on:click="setManifestation('dots')">
                                <img src="/-/themes/main/client/dist/img/manifestations-dots.png">
                                <p>Dots</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-manifestation-type="'squares'"
                                 v-bind:class="manifestation == 'squares' ? activeClass : ''"
                                 v-on:click="setManifestation('squares')">
                                <img src="/-/themes/main/client/dist/img/manifestations-squares.png">
                                <p>Squares</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-manifestation-type="'opalFrostBand'"
                                 v-bind:class="manifestation == 'opalFrostBand' ? activeClass : ''"
                                 v-on:click="setManifestation('opalFrostBand')">
                                <img src="/-/themes/main/client/dist/img/manifestations-opal-band.png">
                                <p>Opal Frost Band</p>
                            </div>
                        </div>

                        <div class="col-6 col-lg-3">
                            <div class="configurator-tile"
                                 v-bind:data-manifestation-type="'opalFrostFull'"
                                 v-bind:class="manifestation == 'opalFrostFull' ? activeClass : ''"
                                 v-on:click="setManifestation('opalFrostFull')">
                                <img src="/-/themes/main/client/dist/img/manifestations-opal-full.png">
                                <p>Opal Frost Full Cover</p>
                            </div>
                        </div>
                    </div>

                    <div class="row section-outro">
                        <div class="col-12 col-lg-9">
                            <p>{{ manifestationsText2 }}</p>
                        </div>
                        <div class="col-12 col-lg-3">
                            <div class="button-wrapper">
                                <a :href="guideToManifestationsLink" target="_blank"
                                   class="btn btn-outline-black configurator-btn">{{ guideToManifestationsLinkText
                                    }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="your-configuration">
                <div class="container">
                    <div class="row introduction">
                        <div class="col-12">
                            <h2>Your configuration</h2>
                            <img class="arrow arrow-right" src="/-/themes/main/client/dist/img/arrow-02.png">
                            <p>{{ yourConfigurationText }}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <hr class="d-md-none"/>

                            <div class="partition-summary d-lg-none">
                                <table class="partition-details">
                                    <tbody>
                                        <tr>
                                            <th>Type of Partition</th>
                                            <td>{{ partitionType }}</td>
                                        </tr>
                                        <tr>
                                            <th>Width</th>
                                            <td>{{ width }}m</td>
                                        </tr>
                                        <tr>
                                            <th>Height</th>
                                            <td>{{ height }}m</td>
                                        </tr>
                                        <tr v-if="partitionType !== partition.inlineType">
                                            <th>Depth</th>
                                            <td>{{ depth }}m</td>
                                        </tr>
                                        <tr>
                                            <th>Glass</th>
                                            <td>{{ glazingTypeString() }}</td>
                                        </tr>
                                        <tr>
                                            <th>Door</th>
                                            <td>{{ doorString() }}</td>
                                        </tr>
                                        <tr>
                                            <th>Manifestation</th>
                                            <td>{{ manifestationString() }}</td>
                                        </tr>
                                        <tr class="divider-row">
                                            <td colspan="3">
                                                <hr/>
                                            </td>
                                        </tr>
                                        <tr class="estimate current-configuration">
                                            <td>
                                                <p>Cost (Estimate)</p>
                                                <p class="cost" v-if="showTotals">&pound;{{ currentConfigurationTotal }}</p>
                                                <p class="cost cost-description" v-else>{{ contactForQuoteText }}</p>
                                            </td>
                                            <td>
                                                <p class="quantity">Quantity</p>
                                                <input class="form-control current-configuration"
                                                       id="current-quantity-mobile" type="number" min="1"
                                                       v-model.number="quantity"
                                                       v-on:input="updateTotalOfAllPartitions()"/>
                                            </td>
                                        </tr>
                                        <tr class="divider-row">
                                            <td colspan="3">
                                                <hr/>
                                            </td>
                                        </tr>

                                        <template v-for="(data, index) in savedPartitions">
                                            <tr v-bind:data-table-row="index">
                                                <th>Type of Partition</th>
                                                <td><p data-heading="Type of Partition">{{ data.partitionType }}</p>
                                                </td>
                                            </tr>
                                            <tr v-bind:data-table-row="index">
                                                <th>Width</th>
                                                <td><p data-heading="Width">{{ data.width }}m</p></td>
                                            </tr>
                                            <tr v-bind:data-table-row="index">
                                                <th>Height</th>
                                                <td><p data-heading="Height">{{ data.height }}m</p></td>
                                            </tr>
                                            <tr v-bind:data-table-row="index"
                                                v-if="data.partitionType !== partition.inlineType">
                                                <th>Depth</th>
                                                <td><p data-heading="Depth">{{ data.depth }}</p></td>
                                            </tr>
                                            <tr v-bind:data-table-row="index">
                                                <th>Glass</th>
                                                <td><p data-heading="Glazing Type">{{
                                                    glazingTypeString(data.glazingType, data.acousticPerformance) }}</p>
                                                </td>
                                            </tr>
                                            <tr v-bind:data-table-row="index">
                                                <th>Door</th>
                                                <td><p data-heading="Door Type">{{ doorString(data.door,
                                                    data.ironmongery) }}</p></td>
                                            </tr>
                                            <tr v-bind:data-table-row="index">
                                                <th>Manifestation</th>
                                                <td><p data-heading="Manifestation Type">{{
                                                    manifestationString(data.manifestation) }}</p></td>
                                            </tr>
                                            <tr class="divider-row">
                                                <td colspan="3">
                                                    <hr/>
                                                </td>
                                            </tr>
                                            <tr class="estimate"
                                                v-bind:data-table-row="index"
                                                v-bind:data-row-count="index"
                                            >
                                                <td>
                                                    <p>Cost (Estimate)</p>
                                                    <p class="cost" data-heading="Cost" v-if="showTotals">&pound;{{ data.grandTotal }}</p>
                                                    <p class="cost cost-description" data-heading="Cost" v-else>{{ contactForQuoteText }}</p>
                                                </td>
                                                <td>
                                                    <p class="quantity">Quantity</p>
                                                    <input class="form-control" type="number" min="1"
                                                           v-model.number="data.quantity"
                                                           v-on:input="updateTotalOfAllPartitions()"/>
                                                    <div class="remove-btn d-flex align-items-center"
                                                         v-on:click="removeSavedPartition(index)"
                                                         v-bind:data-table-row="index">
                                                        <div class="flex-1">
                                                            <i class="fa fa-times"></i>
                                                            <p>Remove</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="divider-row">
                                                <td colspan="3">
                                                    <hr/>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <!--Desktop-->

                            <div class="partition-summary desktop-partition-summary d-none d-lg-block">
                                <table class="partition-details">
                                    <thead>
                                        <tr>
                                            <th>Type of Partition</th>
                                            <th>Dimensions</th>
                                            <th>Glass</th>
                                            <th>Door</th>
                                            <th>Manifestation</th>
                                            <th class="cost-and-quantity">Cost (Estimate)</th>
                                            <td class="pos-relative" rowspan="2"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <img :src="partitionTypeImgPath(partitionType)">
                                                <p>{{ partitionType }}</p>
                                            </td>
                                            <td>
                                                <img src="/-/themes/main/client/dist/img/dimensions-arrow.png">
                                                <p>Width: {{ width }}m</p>
                                                <p>Height: {{ height }}m</p>
                                                <p v-if="partitionType !== partition.inlineType">Depth: {{ depth }}m</p>
                                            </td>
                                            <td>
                                                <img :src="glazingTypeImgPath(glazingType)">
                                                <p>{{ glazingTypeString() }}</p>
                                            </td>
                                            <td>
                                                <img :src="doorImgPath()">
                                                <p>{{ doorString() }}</p>
                                            </td>
                                            <td>
                                                <img :src="manifestationImgPath()">
                                                <p>{{ manifestationString() }}</p>
                                            </td>
                                            <td class="cost-and-quantity current-configuration">
                                                <p class="cost" v-if="showTotals">&pound;{{ currentConfigurationTotal }}</p>
                                                <p class="cost cost-description" v-else>{{ contactForQuoteText }}</p>
                                                <p class="quantity">Quantity</p>
                                                <input class="form-control" id="current-quantity" type="number" min="1"
                                                       v-model.number="quantity"
                                                       v-on:input="updateTotalOfAllPartitions()"/>
                                            </td>
                                        </tr>
                                        <tr class="divider-row">
                                            <td colspan="7">
                                                <hr/>
                                            </td>
                                        </tr>

                                        <template v-for="(data, index) in savedPartitions">
                                            <tr>
                                                <th>Type of Partition</th>
                                                <th>Dimensions</th>
                                                <th>Glass</th>
                                                <th>Door</th>
                                                <th>Manifestation</th>
                                                <th class="cost-and-quantity">Cost (Estimate)</th>
                                                <td class="pos-relative" rowspan="2">
                                                    <div class="remove-btn d-flex align-items-center"
                                                         v-on:click="removeSavedPartition(index)"
                                                         v-bind:data-table-row="index">
                                                        <div class="flex-1">
                                                            <i class="fa fa-times"></i>
                                                            <p>Remove</p>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-bind:data-table-row="index">
                                                <td>
                                                    <img :src="partitionTypeImgPath(data.partitionType)">
                                                    <p data-heading="Type of Partition">{{ data.partitionType }}</p>
                                                </td>
                                                <td>
                                                    <img src="/-/themes/main/client/dist/img/dimensions-arrow.png">
                                                    <p data-heading="Width">Width: {{ data.width }}m</p>
                                                    <p data-heading="Height">Height: {{ data.height }}m</p>
                                                    <p data-heading="Depth"
                                                       v-if="data.partitionType !== partition.inlineType">Depth: {{
                                                        data.depth }}m</p>
                                                </td>
                                                <td>
                                                    <img :src="glazingTypeImgPath(data.glazingType)">
                                                    <p data-heading="Glazing Type">
                                                        {{ glazingTypeString(data.glazingType, data.acousticPerformance)
                                                        }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <img :src="doorImgPath(data.door)">
                                                    <p data-heading="Door Type">
                                                        {{ doorString(data.door, data.ironmongery) }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <img :src="manifestationImgPath(data.manifestation)">
                                                    <p data-heading="Manifestation Type">
                                                        {{ manifestationString(data.manifestation) }}
                                                    </p>
                                                </td>
                                                <td class="cost-and-quantity" v-bind:data-row-count="index">
                                                    <p data-heading="Cost" class="cost" v-if="showTotals">&pound;{{ grandTotal }}</p>
                                                    <p data-heading="Cost" class="cost cost-description" v-else>{{ contactForQuoteText }}</p>
                                                    <p class="quantity">Quantity</p>
                                                    <input class="form-control" type="number" min="1"
                                                           v-model.number="data.quantity"
                                                           v-on:input="updateTotalOfAllPartitions()"/>
                                                </td>
                                            </tr>
                                            <tr class="divider-row">
                                                <td colspan="7">
                                                    <hr/>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <a v-on:click="savePartition()" class="add-partition" href="javascript:void(0);">Add Another
                                Partition <i
                                    class="fa fa-plus"></i></a>
                            <hr/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="summary">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2>Total Estimate</h2>
                            <p class="above-price-text">{{ totalEstimateText }}</p>
                            <div v-observe-visibility="{callback: totalPriceVisibilityChanged}" v-if="showTotals">
                                <h3 v-if="dimensionsAreValid" class="total-price">
                                    <ICountUp
                                        :delay="countupDelay"
                                        :endVal="totalOfAllPartitions"
                                        :options="countupOptions"
                                    />
                                </h3>
                            </div>
                            <p v-else class="total-price-description">{{ contactForQuoteText }}</p>
                            <p class="above-submit-text">{{ aboveSubmitText }}</p>
                            <a v-if="dimensionsAreValid" href="javascript:void(0);" v-on:click="scrollToYourDetails()"
                               class="btn btn-large submit-button" id="submit-quote">Submit</a>
                            <p v-if="dimensionsAreValid === false" class="invalid-dimensions"
                               id="invalid-dimensions-submit">Dimensions are invalid</p>
                        </div>
                        <div class="col-12">
                            <div class="container contact-buttons">
                                <div class="row">
                                    <div class="col-12 col-lg-4">
                                        <a :href="'tel: ' + phoneNumber"><img
                                            src="/-/themes/main/client/dist/img/get-in-touch-icon-02.png">Call</a>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <a href="javascript:void(0);" class="open-chat"><img
                                            src="/-/themes/main/client/dist/img/get-in-touch-icon-03.png">Live chat</a>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <a :href="'mailto: ' + contactEmail" target="_blank"><img
                                            src="/-/themes/main/client/dist/img/get-in-touch-icon-04.png">Email</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="your-details">
                <div id="your-details-anchor"></div>
                <div class="your-details-content" v-if="showYourDetailsSection">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 description">
                                <h2>Your details</h2>
                                <p class="description-text">{{ yourDetailsText }}</p>
                                <img class="arrow arrow-right" src="/-/themes/main/client/dist/img/arrow-02.png">
                            </div>
                            <div class="col-12">
                                <form v-on:submit.prevent="">
                                    <div class="row">

                                        <div class="col-12 col-lg-6">
                                            <div class="form-group">
                                                <label for="name">Name*</label>
                                                <input type="text" class="form-control" id="name"
                                                       v-model="yourDetails.name" required>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-6">
                                            <div class="form-group">
                                                <label for="email">Email address</label>
                                                <input type="email" class="form-control" id="email"
                                                       v-model="yourDetails.email" required>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-6">
                                            <div class="form-group">
                                                <label for="location">Location*</label>
                                                <input type="text" class="form-control" v-model="yourDetails.location"
                                                       id="location" required>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-6">
                                            <div class="form-group">
                                                <label for="phone">Phone*</label>
                                                <input type="text" class="form-control" v-model="yourDetails.phone"
                                                       id="phone" required>
                                            </div>
                                        </div>

                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="howDidYouHearAboutUs">How did you hear about us</label>
                                                <select v-model="yourDetails.howDidYouHearAboutUs" class="form-control"
                                                        id="howDidYouHearAboutUs">
                                                    <option disabled value="">Please select one</option>
                                                    <option>Google</option>
                                                    <option>Radio (LBC)</option>
                                                    <option>Social Media</option>
                                                    <option>Referral</option>
                                                    <option>Online Advertisement</option>
                                                    <option>Other</option>
                                                </select>
                                            </div>

                                        </div>

                                        <div class="col-12 pt-3 text-center">
                                            <p>Complete this form and click "Complete Quote" to have your quote emailed to you</p>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div class="col-12 complete-button-div">
                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="checkbox" id="accept-terms"
                                               value="" v-model="acceptedTerms">
                                        I confirm that I have read and accept The Glass Office People's <a
                                        href="/privacy-policy" target="_blank">Privacy Policy</a> and <a
                                        href="/terms-and-conditions" target="_blank">Terms and
                                        Conditions</a>
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="checkbox" id="promotional-consent"
                                               value="" v-model="yourDetails.promotionalConsent">
                                        I give permission for The Glass Office People to send me promotional e-mail messages with offers and updates. Your information will be used in accordance to our Privacy Policy
                                    </label>
                                </div>
                                <div class="d-flex justify-content-center pt-4 pb-3">
                                    <vue-recaptcha
                                        @verify="recaptchaVerify"
                                        @expired="recaptchaExpired"
                                        sitekey="6LdqIzsUAAAAAEARn-6EzPbyYWp8csl5UALg57B8"
                                    ></vue-recaptcha>
                                </div>
                                <button v-if="dimensionsAreValid" id="complete-quote"
                                        class="btn btn-large submit-button my-4"
                                        v-bind:class="{ formSubmitted: submittedForm }"
                                        v-on:click="completeQuote()"
                                        :disabled="acceptedTerms !== true || recaptchaVerified !== true || submittedForm === true || yourDetails.howDidYouHearAboutUs === ''">
                                    {{
                                    submitQuoteText }} <i v-html="submitIcon"></i></button>
                                <p class="description-text text-center mx-auto" v-if="acceptedTerms !== true">Please accept the terms and conditions</p>
                                <p class="description-text text-center mx-auto" v-if="yourDetailsFormFilledIn === false">{{
                                    pleaseFillInYourDetailsText }}</p>
                                <p class="description-text text-center mx-auto">{{ completeQuoteText }}</p>
                                <div class="bottom-line mt-5"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="finance">
                <div class="container">
                    <div class="row">
                        <div class="col-12 description">
                            <h2>Additional products</h2>
                            <img class="arrow arrow-right" src="/-/themes/main/client/dist/img/arrow-02.png">
                            <div v-html="additionalProductsText"></div>
                            <div class="bottom-line"></div>
                            <h2>{{ financeHeading }}</h2>
                            <img class="arrow arrow-right" src="/-/themes/main/client/dist/img/arrow-02.png">
                            <div v-html="financeText"></div>
                            <div class="bottom-line"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!--<a href="javascript:void(0);" v-on:click="downloadConfig()" class="btn btn-primary">Download config</a>-->

    </div>
</template>

<script>
    import {Partition} from '../objects/Partition';
    import * as Cookies from 'tiny-cookie';
    import * as Math from 'mathjs';
    import ICountUp from 'vue-countup-v2';
    import { VueRecaptcha } from 'vue-recaptcha';

    let cookieName = 'configurator_data';

    let partition = new Partition();

    export default {
        name: 'configurator',
        components: {
            ICountUp,
            VueRecaptcha
        },
        data() {

            let phoneNumber = '';
            let configuratorTextData = {};
            let configurationDataElement = document.getElementById("configurator-text-data");
            if (configurationDataElement !== null) {
                configuratorTextData = JSON.parse(configurationDataElement.innerHTML);
                //                We need to do this so safari doesnt turn the number into a link and break json parsing
                phoneNumber = String(configuratorTextData.PhoneNumber).replace('stopsafari', '');
            }

            return {
                countupDelay: 1000,
                countupOptions: {
                    useEasing: true,
                    useGrouping: true,
                    separator: ',',
                    decimal: '.',
                    prefix: '£',
                    suffix: '',
                    decimalPlaces: 2
                },
                configuratorVersion: '0.7.0',
                submittedForm: false,
                savedPartitions: [],
                activeClass: 'active',
                partition: new Partition(),
                glazingType: partition.singleGlazingType,
                manifestation: 'dots',
                ironmongery: partition.door.ironmongeryDHandle,
                acousticPerformance: partition.singleGlazed33dB,
                partitionType: partition.inlineType,
                door: partition.door.singleGlazedDoorFrameless,
                width: 300,
                height: 1000,
                depth: 300,
                grandTotal: 0,
                totalOfAllPartitions: 0,
                quantity: 1,
                baseDoorImage: '/-/themes/main/client/dist/img/large-doors-base.png',
                singleGlazedDoorOptions: {
                    singleGlazedDoorFrameless: {
                        name: 'Frameless Door',
                        imgPathSmall: '/-/themes/main/client/dist/img/small-doors-single.png',
                        imgPathLarge: '/-/themes/main/client/dist/img/large-doors-frameless.png',
                    },
                    singleGlazedDoorIncFrame: {
                        name: 'Framed Door',
                        imgPathSmall: '/-/themes/main/client/dist/img/small-doors-double.png',
                        imgPathLarge: '/-/themes/main/client/dist/img/large-doors-framed.png'
                    },
                    noDoor: {
                        name: 'No door',
                        imgPathSmall: '/-/themes/main/client/dist/img/small-doors-none.png',
                        imgPathLarge: '/-/themes/main/client/dist/img/large-doors-none.png'
                    },
                },
                doubleGlazedDoorOptions: {
                    singleGlazedDoorIncDoubleGlazedFrame: {
                        name: 'Single Glazed Framed Door',
                        imgPathSmall: '/-/themes/main/client/dist/img/small-doors-single.png',
                        imgPathLarge: '/-/themes/main/client/dist/img/large-doors-frameless.png'
                    },
                    doubleGlazedDoor: {
                        name: 'Double Glazed Framed Door',
                        imgPathSmall: '/-/themes/main/client/dist/img/small-doors-double.png',
                        imgPathLarge: '/-/themes/main/client/dist/img/large-doors-framed.png'
                    },
                    noDoor: {
                        name: 'No door',
                        imgPathSmall: '/-/themes/main/client/dist/img/small-doors-none.png',
                        imgPathLarge: '/-/themes/main/client/dist/img/large-doors-none.png'
                    },
                },
                yourDetails: {
                    name: "",
                    email: "",
                    phone: "",
                    location: "",
                    howDidYouHearAboutUs: "",
                    promotionalConsent: false
                },
                typeOfPartitionText1: configuratorTextData.TypeOfPartitionText1,
                typeOfPartitionText2: configuratorTextData.TypeOfPartitionText2,
                dimensionsText: configuratorTextData.DimensionsText,
                glassText: configuratorTextData.GlassText,
                acousticPerformanceText: configuratorTextData.AcousticPerformanceText,
                doorText: configuratorTextData.DoorText,
                manifestationsText1: configuratorTextData.ManifestationsText1,
                manifestationsText2: configuratorTextData.ManifestationsText2,
                ironmongeryText1: configuratorTextData.IronmongeryText1,
                ironmongeryText2: configuratorTextData.IronmongeryText2,
                guideToIronmongeryLinkText: configuratorTextData.GuideToIronmongeryLinkText,
                guideToIronmongeryLink: configuratorTextData.GuideToIronmongeryLink,
                yourConfigurationText: configuratorTextData.YourConfigurationText,
                totalEstimateText: configuratorTextData.TotalEstimateText,
                phoneNumber: phoneNumber,
                contactEmail: configuratorTextData.ContactEmail,
                yourDetailsText: configuratorTextData.YourDetailsText,
                additionalProductsText: configuratorTextData.AdditionalProductsText,
                completeQuoteText: configuratorTextData.CompleteQuoteText,
                pleaseFillInYourDetailsText: configuratorTextData.PleaseFillInYourDetailsText,
                guideToPartitionsLinkText: configuratorTextData.GuideToPartitionsLinkText,
                guideToPartitionsLink: configuratorTextData.GuideToPartitionsLink,
                guideToDoorsLinkText: configuratorTextData.GuideToDoorsLinkText,
                guideToDoorsLink: configuratorTextData.GuideToDoorsLink,
                guideToManifestationsLinkText: configuratorTextData.GuideToManifestationsLinkText,
                guideToManifestationsLink: configuratorTextData.GuideToManifestationsLink,
                guideToAcousticsLinkText: configuratorTextData.GuideToAcousticsLinkText,
                guideToAcousticsLink: configuratorTextData.GuideToAcousticsLink,
                aboveSubmitText: configuratorTextData.AboveSubmitText,
                financeHeading: configuratorTextData.FinanceHeading,
                financeText: configuratorTextData.FinanceText,
                thankyouPageLink: configuratorTextData.ThankyouPageLink,
                showTotals: (configuratorTextData.ShowTotals === '1'),
                contactForQuoteText: configuratorTextData.ContactForQuoteText,
                submitIcon: '',
                submitQuoteText: 'Complete quote',
                acceptedTerms: false,
                promotionalConsent: false,
                showYourDetailsSection: false,
                recaptchaVerified: false
            }
        },
        watch: {
            glazingType: function (glazing) {
                if (this.isSingleGlazed === true) {
                    // If the currently selected door is not allowed for single glazing types
                    if (!this.singleGlazedDoorOptions.hasOwnProperty(this.door)) {
                        this.door = this.partition.door.noDoor;
                    }
                }
                if (this.isDoubleGlazed === true) {
                    if (!this.doubleGlazedDoorOptions.hasOwnProperty(this.door)) {
                        this.door = this.partition.door.noDoor;
                    }
                }
            },
        },
        computed: {
            yourDetailsFormFilledIn() {
                return Boolean(
                    this.yourDetails.name !== '' &&
                    this.yourDetails.email !== '' &&
                    this.yourDetails.location !== '' &&
                    this.yourDetails.phone !== '' &&
                    this.yourDetails.howDidYouHearAboutUs
                )
            },
            widthWarning() {
                return this.dimensionsErrorMessage(this.width, 'Width');
            },
            heightWarning() {
                return this.dimensionsErrorMessage(this.height, 'Height');
            },
            depthWarning() {
                if (this.notInlinePartition) {
                    return this.dimensionsErrorMessage(this.depth, 'Depth');
                }
                return false;
            },
            dimensionsAreValid() {
                return Boolean(
                    (this.widthWarning === false) && (this.depthWarning === false) && (this.heightWarning === false)
                );
            },
            selectedDoorImage() {
                if (this.isSingleGlazed === true) {
                    return this.singleGlazedDoorOptions[this.door].imgPathLarge;
                }
                if (this.isDoubleGlazed === true) {
                    return this.doubleGlazedDoorOptions[this.door].imgPathLarge;
                }
                return this.baseDoorImage;
            },
            notInlinePartition() {
                return Boolean(this.partitionType !== this.partition.inlineType);
            },
            isSingleGlazed() {
                return Boolean(this.glazingType === this.partition.singleGlazingType);
            },
            isDoubleGlazed() {
                return Boolean(this.glazingType === this.partition.doubleGlazingType);
            },
            currentConfigurationTotal() {
                this.partition.type = this.partitionType;
                this.partition.width = this.width;
                this.partition.height = this.height;
                this.partition.depth = this.depth;

                let chosenManifestation = this.manifestation;
                switch (chosenManifestation) {
                    case 'dots':
                    case 'squares':
                        chosenManifestation = this.partition.manifestation.dotsOrSquares;
                        break;
                }

                try {
                    this.partition.manifestation.type = chosenManifestation;
                    this.partition.setGlazingType(this.glazingType);
                    this.partition.setAcousticPerformance(this.acousticPerformance);
                    this.partition.door.type = this.door;
                    this.partition.door.ironmongery = this.ironmongery;
                    this.grandTotal = this.partition.grandTotal;
                    return this.partition.grandTotal;
                } catch (err) {
                    // console.log('Error Occurred', err);
                    // console.log(err);
                }
            },
        },
        methods: {
            scrollToYourDetails() {
                this.showYourDetailsSection = true;
                this.$scrollTo('#your-details-anchor')
            },
            totalPriceVisibilityChanged(isVisible, entry) {
                let countup = this.$children[0];
                countup.reset();
                // countup.update(this.totalOfAllPartitions);
                countup.update(this.totalOfAllPartitions);
            },
            dimensionsErrorMessage(value, name) {

                let min = 300;
                let max = 20000;

                if (name === 'Height') {
                    min = 1000;
                    max = 3000;
                }

                if (value < min || value > max) {
                    return min + 'mm min to ' + max + 'mm max';
                }
                return false;
            },
            dataForCookie() {
                return {
                    current: {
                        partitionType: this.partitionType,
                        height: this.height,
                        depth: this.depth,
                        width: this.width,
                        manifestation: this.manifestation,
                        acousticPerformance: this.acousticPerformance,
                        ironmongery: this.ironmongery,
                        glazingType: this.glazingType,
                        door: this.door,
                        grandTotal: this.grandTotal,
                        quantity: this.quantity,
                    },
                    yourDetails: this.yourDetails,
                    savedPartitions: this.savedPartitions,
                    totalOfAllPartitions: this.totalOfAllPartitions,
                    configuratorVersion: this.configuratorVersion
                }
            },
            recaptchaVerify(response) {
                console.log('Recaptcha verified');
                this.recaptchaVerified = true;
            },
            recaptchaExpired(response) {
                console.log('Recaptcha expired');
                this.recaptchaVerified = false;
            },
            completeQuote() {

                if (this.acceptedTerms === true && this.recaptchaVerified === true && this.submittedForm === false) {

                    this.submittedForm = true;

                    // To ensure the totals and cookie is up to date;
                    this.updateTotalOfAllPartitions();

                    let partitions = [
                        {
                            partitionType: this.partitionType,
                            height: this.height + 'mm',
                            depth: this.depth + 'mm',
                            width: this.width + 'mm',
                            manifestation: this.manifestationString(this.manifestation),
                            glazingType: this.glazingTypeString(this.glazingType, this.acousticPerformance),
                            door: this.doorString(this.door, this.ironmongery),
                            grandTotal: '£' + this.grandTotal,
                            quantity: this.quantity,
                        },
                    ];


                    if (this.savedPartitions !== undefined) {
                        for (let i = 0; i < this.savedPartitions.length; i++) {
                            let partition = this.savedPartitions[i];
                            partitions.push({
                                partitionType: partition.partitionType,
                                height: partition.height + 'mm',
                                depth: partition.depth + 'mm',
                                width: partition.width + 'mm',
                                manifestation: this.manifestationString(partition.manifestation),
                                glazingType: this.glazingTypeString(partition.glazingType, partition.acousticPerformance),
                                door: this.doorString(partition.door, partition.ironmongery),
                                grandTotal: '£' + partition.grandTotal,
                                quantity: partition.quantity,
                            });
                        }
                    }

                    let yourDetails = this.yourDetails;
                    let totalOfAllPartitions = '£' + this.totalOfAllPartitions;

                    let body = {
                        partitions: JSON.stringify(partitions),
                        yourDetails: JSON.stringify(yourDetails),
                        totalOfAllPartitions: JSON.stringify(totalOfAllPartitions),
                    };

                    this.$http.post(window.location.href + '/send',
                        body,
                    ).then(response => {
                        if (response.status === 200) {
                            this.submitQuoteText = 'Quote submitted';
                            this.submitIcon = '<i class="fas fa-check" aria-hidden="true"></i>';
                            window.location.href = this.thankyouPageLink;
                        }
                    }, response => {
                        this.submitQuoteText = 'Quote not submitted';
                        this.submitIcon = '<i class="fas fa-times" aria-hidden="true"></i>';
                        alert('Your submission could not be completed, please try again later.');
                        this.submittedForm = false;
                    });

                }

            },
            updateTotalOfAllPartitions() {
                let total = (this.currentConfigurationTotal * this.quantity);
                if (this.savedPartitions !== undefined) {
                    for (let i = 0; i < this.savedPartitions.length; i++) {
                        total += (Number(this.savedPartitions[i].grandTotal) * Number(this.savedPartitions[i].quantity));
                    }
                }
                this.totalOfAllPartitions = Math.round(total, 2);
                this.forceUpdate();
                Cookies.set(cookieName, JSON.stringify(this.dataForCookie()), 1);
            },
            forceUpdate() {
                this.$forceUpdate();
            },
            savePartition() {
                let partitionData = {
                    "partitionType": this.partitionType,
                    "height": this.height,
                    "depth": this.depth,
                    "width": this.width,
                    "manifestation": this.manifestation,
                    "glazingType": this.glazingType,
                    "acousticPerformance": this.acousticPerformance,
                    "ironmongery": this.ironmongery,
                    "door": this.door,
                    "grandTotal": this.currentConfigurationTotal,
                    "quantity": this.quantity
                };
                // Add the current partition to the array
                this.savedPartitions.unshift(partitionData);

                // Reset the configurator values to their original values
                this.glazingType = this.partition.singleGlazingType;
                this.manifestation = 'dots';
                this.partitionType = this.partition.inlineType;
                this.acousticPerformance = this.partition.singleGlazed33dB;
                this.ironmongery = this.partition.door.ironmongeryDHandle;
                this.door = this.partition.door.singleGlazedDoorFrameless;
                this.width = 1000;
                this.height = 1000;
                this.depth = 1000;
                this.quantity = 1;
                this.updateTotalOfAllPartitions();
                this.$scrollTo('#type-of-partition-section-anchor');
            },
            removeSavedPartition(index) {
                this.savedPartitions.splice(index, 1);
                this.updateTotalOfAllPartitions();
            },
            partitionTypeImgPath(string) {
                if (string === undefined) {
                    string = this.partitionType;
                }
                switch (string) {
                    case this.partition.inlineType:
                        return '/-/themes/main/client/dist/img/inline-glass-box.png';
                        break;
                    case this.partition.cornerType:
                        return '/-/themes/main/client/dist/img/corner-glass-box.png';
                        break;
                    case this.partition.threeSidedType:
                        return '/-/themes/main/client/dist/img/three-sided-glass-box.png';
                        break;
                    case this.partition.tShapeType:
                        return '/-/themes/main/client/dist/img/t-glass-box.png';
                        break;
                    default:
                        return '';
                        break;
                }
            },
            glazingTypeString(glazingType, acousticPerformance) {
                if (glazingType === undefined) {
                    glazingType = this.glazingType;
                }
                if (acousticPerformance === undefined) {
                    acousticPerformance = this.acousticPerformance;
                }

                let acousticPerformanceString = '';

                switch (acousticPerformance) {
                    case this.partition.singleGlazed33dB:
                        acousticPerformanceString = '(33dB)';
                        break;
                    case this.partition.singleGlazed38dB:
                        acousticPerformanceString = '(38dB)';
                        break;
                    default:
                        return '';
                        break;
                }

                switch (glazingType) {
                    case this.partition.singleGlazingType:
                        return 'Single Glazed ' + acousticPerformanceString;
                        break;
                    case this.partition.doubleGlazingType:
                        return 'Double Glazed';
                        break;
                    default:
                        return '';
                        break;
                }
            },
            glazingTypeImgPath(string) {
                if (string === undefined) {
                    string = this.glazingType;
                }
                switch (string) {
                    case 'single':
                        return '/-/themes/main/client/dist/img/glass-single.png';
                        break;
                    case 'double':
                        return '/-/themes/main/client/dist/img/glass-double.png';
                        break;
                    default:
                        return '';
                        break;
                }
            },
            doorImgPath(string) {
                if (string === undefined) {
                    string = this.door;
                }
                switch (string) {
                    case 'noDoor':
                        return '/-/themes/main/client/dist/img/small-doors-none.png';
                        break;
                    case 'singleGlazedDoorFrameless':
                    case 'singleGlazedDoorIncDoubleGlazedFrame':
                        return '/-/themes/main/client/dist/img/small-doors-single.png';
                        break;
                    case 'singleGlazedDoorIncFrame':
                    case 'doubleGlazedDoor':
                        return '/-/themes/main/client/dist/img/small-doors-double.png';
                        break;
                    default:
                        return '';
                        break;
                }
            },
            doorString(door, ironmongery) {

                if (door === undefined) {
                    door = this.door;
                }

                if (ironmongery === undefined) {
                    ironmongery = this.ironmongery;
                }

                let ironmongeryString = '';

                switch (ironmongery) {
                    case this.partition.door.ironmongeryDHandle:
                        ironmongeryString = '(D Handle)';
                        break;
                    case this.partition.door.ironmongeryManet:
                        ironmongeryString = '(Manet Handle)';
                        break;
                    case this.partition.door.ironmongeryLeverLock:
                        ironmongeryString = '(Lever Lock Handle)';
                        break;
                    default:
                        return '';
                        break;
                }

                switch (door) {
                    case 'noDoor':
                        return 'No Door';
                        break;
                    case 'singleGlazedDoorFrameless':
                        return 'Frameless Door ' + ironmongeryString;
                        break;
                    case 'singleGlazedDoorIncDoubleGlazedFrame':
                    case 'singleGlazedDoorIncFrame':
                        return 'Single Glazed Framed Door ' + ironmongeryString;
                        break;
                    case 'doubleGlazedDoor':
                        return 'Double Glazed Framed Door ' + ironmongeryString;
                        break;
                    default:
                        return '';
                        break;
                }

            },
            manifestationImgPath(string) {
                if (string === undefined) {
                    string = this.manifestation;
                }
                switch (string) {
                    case 'dots':
                        return '/-/themes/main/client/dist/img/manifestations-dots.png';
                        break;
                    case 'squares':
                        return '/-/themes/main/client/dist/img/manifestations-squares.png';
                        break;
                    case 'opalFrostBand':
                        return '/-/themes/main/client/dist/img/manifestations-opal-band.png';
                        break;
                    case 'opalFrostFull':
                        return '/-/themes/main/client/dist/img/manifestations-opal-full.png';
                        break;
                    default:
                        return '';
                        break;
                }
            },
            manifestationString(string) {
                if (string === undefined) {
                    string = this.manifestation;
                }
                switch (string) {
                    case 'dots':
                        return 'Dots';
                        break;
                    case 'squares':
                        return 'Squares';
                        break;
                    case 'opalFrostBand':
                        return 'Opal Frost Band';
                        break;
                    case 'opalFrostFull':
                        return 'Opal Frost Full Cover';
                        break;
                    default:
                        return '';
                        break;
                }
            },
            setPartitionType(type) {
                this.partitionType = type;
                this.updateTotalOfAllPartitions();
            },
            setGlazingType(type) {
                // don't need to do this unless they are changing type
                if (this.glazingType !== type) {
                    // if the door is set to anything other than no door
                    if (this.door !== this.partition.door.noDoor) {
                        switch (type) {
                            case this.partition.singleGlazingType:
                                this.door = this.partition.door.singleGlazedDoorFrameless;
                                break;
                            case this.partition.doubleGlazingType:
                                this.door = this.partition.door.singleGlazedDoorIncDoubleGlazedFrame;
                                break;
                            default:
                        }
                    }
                }
                this.glazingType = type;

                this.updateTotalOfAllPartitions();
            },
            setAcousticPerformance(type) {
                this.acousticPerformance = type;
                this.updateTotalOfAllPartitions();
            },
            setManifestation(type) {
                this.manifestation = type;
                this.updateTotalOfAllPartitions();
            },
            setIronmongery(type) {
                this.ironmongery = type;
                this.updateTotalOfAllPartitions();
            },
            setDoor(type, imgPathLarge) {
                this.door = type;
                if (imgPathLarge !== undefined) {
                    this.selectedDoorImage = imgPathLarge;
                }
                this.updateTotalOfAllPartitions();
            },
            downloadConfig() {
                let object = {
                    "partitionType": this.partitionType,
                    "height": this.height,
                    "depth": this.depth,
                    "width": this.width,
                    "manifestation": this.manifestation,
                    "ironmongery": this.ironmongery,
                    "acousticPerformance": this.acousticPerformance,
                    "glazingType": this.glazingType,
                    "door": this.door,
                    "debugInfo": {
                        "calculatedWidth": this.partition.calculatedWidth,
                        "calculatedHeight": this.partition.calculatedHeight,
                        "calculatedDepth": this.partition.calculatedDepth,
                        "gasketComponents": this.partition.gasketComponents,
                        "numberOfTracks": this.partition.numberOfTracks,
                        "gasketsInMeters": this.partition.gasketsInMeters,
                        "glassSurfaceArea": this.partition.glassSurfaceArea,
                        "marginPercentage": this.partition.marginPercentage,
                        "numberOfAbutments": this.partition.numberOfAbutments
                    },
                    "componentPriceTotals": {
                        "gasketTotal": this.partition.gasketTotalInPence,
                        "abutmentTotal": this.partition.abutmentTotalInPence,
                        "manifestationTotal": this.partition.manifestation.totalInPence,
                        "tracksTotal": this.partition.tracksTotalInPence,
                        "glassTotal": this.partition.glassTotalInPence,
                        "doorTotal": this.partition.door.totalInPence,
                        "labourTotal": this.partition.labourTotalInPence,
                        "additionalCosts": this.partition.additionalCostsInPence,
                    },
                    "subTotal": this.partition.subTotalInPence,
                    "marginPercentage": this.partition.marginPercentage,
                    "marginTotal": this.partition.marginTotalInPence,
                    "grandTotal": this.grandTotal
                };

                let debugContentString = JSON.stringify(object, null, '\t');
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(debugContentString));
                element.setAttribute('download', 'configuratorDebug.json');
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            },
        },
        mounted: function () {
            this.$nextTick(function () {

                let data = undefined;
                if (cookieName !== undefined) {
                    if (Cookies.get(cookieName) !== null) {

                        data = JSON.parse(Cookies.get(cookieName));

                        if (data.configuratorVersion === this.configuratorVersion) {
                            this.partitionType = data.current.partitionType;
                            this.height = data.current.height;
                            this.depth = data.current.depth;
                            this.width = data.current.width;
                            this.manifestation = data.current.manifestation;
                            this.glazingType = data.current.glazingType;
                            this.acousticPerformance = data.current.acousticPerformance;
                            this.ironmongery = data.current.ironmongery;
                            this.door = data.current.door;
                            this.grandTotal = data.current.grandTotal;
                            this.quantity = data.current.quantity;
                            this.yourDetails = data.yourDetails;
                            this.savedPartitions = data.savedPartitions;
                            this.totalOfAllPartitions = data.totalOfAllPartitions;
                        } else {
                            Cookies.remove(cookieName);
                        }
                    }
                }
                this.updateTotalOfAllPartitions();
            })
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Configurator.vue